import React, { useEffect, useState } from "react";
import usersStore from "../../../stores/usersStore";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import UsersColumn from "../UsersColumn";
import UsersRow from "../UsersRow";

// Icon
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

const AllUserTabs = ({
  dataLoading,
  userName,
  email,
  phoneNo,
  gender,
  status,
  staringDate,
  endingDate,
}) => {
  const UsersStore = usersStore();
  const [rows, setRows] = useState(null);
  const [emptyRows, setEmptyRows] = useState(null);
  const [visibleRows, setVisibleRows] = useState(null);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  useEffect(() => {
    if (!UsersStore.isLoading && UsersStore.allUser) {
      const editUser = [];
      UsersStore.allUser.map((user, index) => {
        editUser.push({
          // sno: index + 1,
          _id: user._id,
          fullName: user.firstName + " " + user.lastName,
          email: user.email,
          phoneNumber: user.phoneNumber,
          joiningDate: user.created_at,
          gender: user.gender ? (user.gender === "M" ? "Male" : "Female") : "-",
          status:
            user.status === 0
              ? "Active"
              : user.status === 1
              ? "Banned"
              : "Deleted",
        });
      });
      if (editUser.length) {
        setRows(editUser);
      }
    }
  }, [UsersStore.isLoading]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const setRowData = ({ myRows }) => {
    const data = stableSort(myRows, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    setVisibleRows(data);

    const emptyRowsData =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - myRows.length) : 0;
    setEmptyRows(emptyRowsData);
  };

  useEffect(() => {
    if (rows) {
      let filterData = rows;
      if (UsersStore.userFilterApply !== 0) {
        if (userName !== "") {
          const usernameFilter = filterData.filter((item) => {
            return item.fullName.toLowerCase().includes(userName.toLowerCase());
          });
          filterData = usernameFilter;
        }

        if (email !== "") {
          const emailFilter = filterData.filter((item) => {
            return item.email.toLowerCase().includes(email.toLowerCase());
          });
          filterData = emailFilter;
        }

        if (phoneNo !== "") {
          const phoneNoFilter = filterData.filter((item) => {
            return item.phoneNumber
              .toLowerCase()
              .includes(phoneNo.toLowerCase());
          });
          filterData = phoneNoFilter;
        }

        if (gender !== "") {
          const genderFilter = filterData.filter((item) => {
            if (gender === "Not Define" && item.gender === "-") {
              return item;
            }
            if (item.gender === gender) {
              return item;
            }
          });
          filterData = genderFilter;
        }

        if (staringDate !== null && endingDate !== null) {
          const dateFilter = filterData.filter((item) => {
            const joiningDate = new Date(item.joiningDate);
            if (staringDate <= joiningDate && joiningDate <= endingDate) {
              return item;
            }
          });
          filterData = dateFilter;
        }

        if (status !== "") {
          const statusFilter = filterData.filter((item) => {
            if (status === item.status) {
              return item;
            }
          });
          filterData = statusFilter;
        }
      }
      if (filterData.length) {
        setRowData({ myRows: filterData });
      } else {
        setVisibleRows(null);
      }
    }
  }, [UsersStore.userFilterApply, order, orderBy, page, rowsPerPage, rows]);

  return (
    <div>
      <TableContainer>
        <Table aria-label="collapsible table" size={dense ? "small" : "medium"}>
          <UsersColumn
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={visibleRows ? visibleRows.length : 0}
            dataLoading={dataLoading}
          />
          <TableBody>
            {visibleRows ? (
              visibleRows
                .slice(0)
                .reverse()
                .map((row, index) => (
                  <UsersRow key={row._id} row={row} index={index} />
                ))
            ) : (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * 5,
                }}
              >
                <TableCell colSpan={8}>
                  <div className="no-user-data">
                    <div className="content">
                      <DescriptionRoundedIcon className="icon" />
                      <p>{dataLoading ? "Loading..." : "No Data"}</p>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * emptyRows,
                }}
              >
                <TableCell colSpan={8} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={visibleRows ? visibleRows.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default AllUserTabs;
